import { EMAIL_REGEXP } from '../../regExp';

const validateEmail = (email: string): boolean => EMAIL_REGEXP.test(email);

export default validateEmail;
